<template>
  <lazy-app-dialog
    v-if="isOpen"
    v-model="isOpen"
    :header="false"
    :width="870"
    @close="acknowledge"
  >
    <div class="grid gap-8 md:grid-cols-[55%_1fr]">
      <div class="order-2 md:order-1">
        <h2 class="mb-3 text-2xl/snug font-extrabold">
          Vous souhaitez intégrer l'IA dans vos équipes ?
        </h2>

        <p class="text-subtle mb-6">
          Découvrez notre KIT Pollen par les meilleurs experts.
        </p>

        <ul class="text-subtle grid gap-3">
          <li v-for="item in list" :key="item.icon" class="flex gap-3">
            <app-icon
              class="bg-primary-100 text-primary rounded p-1"
              :icon="item.icon"
              :size="32"
            />
            <p v-html="item.label" />
          </li>
        </ul>

        <growth-contact-button
          block
          class="mt-8"
          color="primary"
          origin="ai_kit_dialog"
          origin_page_action="ai_kit_download_cta"
          size="lg"
          @click="acknowledge"
        >
          Télécharger le kit
        </growth-contact-button>
      </div>

      <app-image
        alt=""
        class="order-1 aspect-[2.3] h-full rounded-xl object-cover md:order-2 md:aspect-auto"
        src="https://res.cloudinary.com/dfdgwwkpd/image/upload/v1764171160/brand/events/Design_sans_titre_oa217r.jpg"
        :width="800"
      />
    </div>
  </lazy-app-dialog>
</template>

<script lang="ts" setup>
const DIALOG_AUTO_SHOW_DELAY_IN_MS = 8000;

const list: { label: string; icon: string }[] = [
  {
    icon: "ph:popcorn-duotone",
    label: "+50 contenus IA organisés par thématiques",
  },
  {
    icon: "ph:books-duotone",
    label: "Des présentations, événements et articles exclusifs",
  },
  {
    icon: "ph:ranking-duotone",
    label: "Les REX des leaders du marché (L’Oréal, Schneider, Doctolib…)",
  },
];

const { me } = useCurrentUser();
const [isOpen, toggle] = useToggle();
const { hasCompletePII } = useGrowthContact();
const { hasActiveDialog } = useActiveDialogs();

const aiKitDialogAcknowledged = useCookie("ai_kit_dialog_acknowledged", {
  maxAge: 60 * 60 * 24 * 7,
  default: () => false,
});

function acknowledge() {
  aiKitDialogAcknowledged.value = true;
  toggle(false);
}

const route = useRoute();

const isBlacklistedForCurrentRoute = computed(() => {
  // Never cover a registration link: the visitor came here to enrol, not to read an ad
  if (route.query.registration_token !== undefined) return true;

  return (
    route.path.startsWith("/auth") ||
    route.path.startsWith("/assessment") ||
    route.name === "contact"
  );
});

if (import.meta.client && !aiKitDialogAcknowledged.value) {
  await timer(DIALOG_AUTO_SHOW_DELAY_IN_MS);

  if (
    !me.value &&
    !hasCompletePII.value &&
    !isBlacklistedForCurrentRoute.value &&
    !hasActiveDialog.value
  ) {
    toggle(true);
  }
}
</script>
